const testGroups = JSON.parse(localStorage.getItem("abconvert-experiment-to-group-index"));
const productIdValue = document.querySelector('product-info').dataset.productId;
const variantIdValue = document.querySelector('form input[name="id"]').value;
const experimentId = window.abconvertPriceCartTransformTestDict?.[productIdValue]?.experimentId;
const userGroupIndex = testGroups?.[experimentId]; // e.g. 0 or 1

const priceData = window.abconvertPriceCartTransformTestDict?.[productIdValue]?.variantToGroupIndexToPrice?.[variantIdValue]?.[userGroupIndex];

const isAbTestRunning =
  testGroups != null &&
  typeof userGroupIndex === "number" &&
  priceData != null;

if (isAbTestRunning) {
  // Shopify data-price expects price in cents (e.g. 259 → 25900)
  const priceInCents = Math.round(Number(priceData.price) * 100);
  const buyPriceEl = document.querySelector("product-buy-price[data-price]");
  if (buyPriceEl) {
    buyPriceEl.setAttribute("data-price", priceInCents);
  }
}